import { HTMLTable } from "./HTMLTable";
import { ICoreFrameGridOptions, totalFunction } from "../Interfaces";
import { CoreFrameGrid } from "../index";
import { Constants } from "../Constants";
export class TotalRowTable extends HTMLTable {

    /**
     * Der Tabellenkopf
     */
    tfoot: HTMLElement = undefined;

    constructor(options: ICoreFrameGridOptions, grid: CoreFrameGrid) {
        super('TotalRowTable', options, grid);
        this.tfoot = document.createElement('tfoot');

        this.$table.append(this.tfoot);

        this.$wrapper[0].style.overflow = 'hidden';
        this.$wrapper[0].style.position = 'relative';
    }

    private clearFoot(){
        let trs = this.tfoot.getElementsByTagName('tr');
        for (let i = trs.length-1; i >= 0 ; i--) {
            let item = trs[i];
            item.remove();
        }
    }

    public RefreshTotalRow(rows: Array<any>): void{
        if(this.grid.getOptions().hasTotalRow)
        {
            this.clearFoot();
            const totalRow = this.CreateTotalRow(rows);
            this.tfoot.appendChild(totalRow);
        }
    }

    private CreateTotalRow(rows: Array<any>): HTMLTableRowElement {
        let cols = this.grid.getAllVisibleLeafColumns();
        let tr = document.createElement('tr');
        tr.classList.add(Constants.CLASS_ROW);
        tr.setAttribute('role', 'row');
        let thMain = document.createElement('th');
        thMain.setAttribute('role', 'gridcell');

        for (let colIndex = 0; colIndex < cols.length; colIndex++) {
            let currentCol = cols[colIndex];

            let uiGenerator = this.ResolveTotal(currentCol.total);
            
            let th = thMain.cloneNode() as HTMLTableCellElement;
                        
            let cellContent: any = uiGenerator(rows);
            if (cellContent && typeof cellContent === 'object' && typeof cellContent.then === 'function') {
                // handle a promise
                cellContent.then((value) => {
                    if (value == null || value == undefined) {
                        th.setAttribute('data-isnull', true.toString());
                    }
                    th.appendChild(value);
                });
            } else {
                if (cellContent == null || cellContent == undefined) {
                    th.setAttribute('data-isnull', true.toString());
                }
                
                if (typeof cellContent === 'object') {
                    let obj = cellContent;
                    if (obj != null) {
                        if (obj.length > 0) {
                            for (let i = 0; i < obj.length; i++) {
                                th.appendChild(obj[i]);
                            }
                        } else {
                            th.appendChild(obj);
                        }
                    }
                } else {
                    // handle a concrete value
                    th.innerHTML = cellContent;
                }
            }

            // Klasse der Zelle setzen
            if (currentCol.dataClass)
                th.classList.add(currentCol.dataClass);

            th.setAttribute('data-column', currentCol.name);

            if (this.grid.useLocator())
                th.setAttribute('data-locator', this.options.locator + '.totalrow.col.[' + currentCol.name + ']' + '.' + colIndex);

            tr.appendChild(th);
        }

        // auffüllende Spalte
        if (this.grid.useFillColumn) {
            let fillCell = thMain.cloneNode() as HTMLTableCellElement;
            fillCell.classList.add(Constants.CLASS_CELL_FILLCOLUMN);
            tr.append(fillCell);
        }

        // Damit beim vertikale Scrollen die Spalten übereinander bleiben
        const scrollColumn = document.createElement('th');
        tr.append(scrollColumn);

        return tr;
    }

    private ResolveTotal(uiGenerator: string | totalFunction): totalFunction {
        if (typeof uiGenerator == "function") {
            return uiGenerator;
        }

        return (rows) => {
            return uiGenerator;
        }
    }
}
